<!-- Search expanded Section start -->
<div class="row align-items-center" [ngClass]="{'ml-4 pl-2':!showNav, ' ml-2': showNav}">
  <div class="col-auto px-0">
    <button type="button" (click)="backwardNavigation();" *ngIf="showBackwardNav" aria-label="Go back"
      class="btn btn-icon py-2 pr-2 pl-0">
      <em class="ic-flip custom-ic-flip align-text-top material-icons-outlined text-blue" aria-hidden="true">arrow_forward_ios</em>
    </button>
  </div>

  <div class="col-10 pl-0">
    <span class="position-absolute">
      <em class="material-icons-outlined mt-1 search-icon" aria-hidden="true">search</em>
    </span>
    <label for="searchTaxonomies" class="sr-only">Search</label>
    <input *ngIf="!isAdvanceSearch && !isAdvSearchFrontfacing" type="search" placeholder="Search {{searchPlaceholder | titlecase}}"
      aria-haspopup="false" autocomplete="off" aria-autocomplete="both" autocorrect="off" autocapitalize="off"
      aria-required="false" class="form-control search-inputfield" [(ngModel)]="searchText" id="searchTaxonomies"
      (keyup)="emitSearchText()">
      <!-- UF-46671 -->
    <input [disabled]="disebleAdvSearchFrontFacingInput" *ngIf="isAdvSearchFrontfacing" type="search" placeholder="Advanced Search {{searchPlaceholder | titlecase}}"
      aria-haspopup="false" autocomplete="off" aria-autocomplete="both" autocorrect="off" autocapitalize="off"
      aria-required="false" class="form-control search-inputfield" [(ngModel)]="searchTextAdvSearchFrontfacing" id="searchTaxonomies"
      (keyup)="emitSearchText()" >
      <button [disabled]="disebleAdvSearchFrontFacingInput" [ngStyle]="{'display': disebleAdvSearchFrontFacingInput ? 'none' : 'block'}" type="button" class="btn-clear cursor-pointer position-absolute search-clear border-0"
      *ngIf="isAdvSearchFrontfacing && searchTextAdvSearchFrontfacing && searchTextAdvSearchFrontfacing.length" 
      aria-label="Clear search" id="clearBtn" (click)="clearAdvSearchFrontfacing();">&times;</button>
      <!-- UF-46671 -->
    <input *ngIf="isAdvanceSearch" type="search" class="form-control search-inputfield" aria-haspopup="false"
      aria-autocomplete="both" autocorrect="off" autocapitalize="off" aria-required="false"
      placeholder="Search {{searchPlaceholder | titlecase}}" [(ngModel)]="searchKeyword" id="searchTaxonomies"
      (keyup.enter)="search();captureAnalytics()" autocomplete="off" (keyup)="toggleSearchSuggestion($event,'toggle')"
      (click)="toggleSearchSuggestion($event,'toggle')" (clickOutside)="toggleSearchSuggestion($event,'close')">
    <button type="button" class="btn-clear cursor-pointer position-absolute search-clear border-0"
      *ngIf="((isAdvanceSearch && searchKeyword && searchKeyword.length) || (!isAdvanceSearch && searchText && searchText.length)) && !isAdvSearchFrontfacing"
      aria-label="Clear search" id="clearBtn" (click)="clearSearchKeyword();">&times;</button>

    <span class="sr-only" role="alert">{{textMessage}}</span>

    <!-- Search auto complete -->

    <div class="search-suggession position-absolute bg-white" id="search-suggession-panel" style="display:none">
      <div class="row">
        <div class="col-6">
          <div class="search-suggession-block">
            <h2 class="font-bold search-suggession-block--title text-uppercase">Recent Search</h2>
            <ul class="list-group p-0">
              <li class="list-group-item p-0 border-0" *ngFor="let item of recentSearchList| slice:0:5">
                <div class="w-100 d-flex align-items-center">
                  <div class="col-auto px-0 py-1 term">
                    <button class="btn btn-clear btn-block text-left p-0 px-1" data-toggle="modal"
                      data-target="#searchResult" (click)="openSavedSearch(item);">
                      <span class="d-block text-truncate">{{item['search_details']['search_term']}}</span>
                    </button>
                  </div>
                  <div class="col-auto px-0 py-1 filters">
                    <span class="d-block text-truncate font-2x"><span class="dim">in</span>
                      {{getSearchFrom(item['search_details']['search_optional_filters'])}}</span>
                  </div>
                </div>

              </li>
            </ul>
          </div>
        </div>

        <div class="col-6">
          <div class="search-suggession-block">
            <h2 class="font-bold search-suggession-block--title text-uppercase">Saved Searches</h2>
            <ul class="list-group px-0 py-1">
              <li class="list-group-item p-0 border-0" *ngFor="let item of savedSearchList| slice:0:5">
                <button class="btn btn-clear btn-block text-left p-1" (click)="openSavedSearch(item);">
                  <span class="d-flex text-truncate">{{item.title}}</span></button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row search-suggession-footer">
        <div class="col"><button type="button" class="btn btn-clear btn-sm p-0 text-blue" data-toggle="modal"
            data-target="#viewAllRecent" *ngIf="recentSearchList.length > 5">view all
          </button></div>
        <div class="col"><button type="button" class="btn btn-clear btn-sm p-0 text-blue" data-toggle="modal"
            data-target="#viewAllSaved" *ngIf="savedSearchList.length > 5">view all
          </button></div>
      </div>
    </div>
  </div>
  <!-- UF-46671 -->
  <div class="col-auto px-0" >
    <button [disabled]="disabledAdvSearchFrontfacing" type="button" class="btn btn-rounded btn-ds--secondary btn-sm" (click)="advSearchFrontFacing($event,advSearchFrontfacingTitle)">
      {{advSearchFrontfacingTitle}}
    </button>
  </div>
  <!-- UF-46671 -->
  <div *ngIf="isAdvanceSearch" class="col-auto pl-0">
    <button class="btn btn-clear text-underline btn-sm" data-toggle="modal" (click)="cancleSaveSearch();"
      data-target="#saveSearch" [disabled]="!(searchKeyword && searchKeyword.length > 2)">Save Search<span
        class="sr-only">Opens in a new dialog</span>
    </button>
  </div>


</div>
<!-- Search expanded Section End -->



<!-- Search Filter start -->
<div class="col-12 px-0 py-2 search-filter" id="div-search-panel" *ngIf="showBackwardNav"
  [ngClass]="{'ml-4 pl-1':!showNav, '': showNav}">
  <ng-container *ngIf="filterDataLoaded && enableAdvanceSearch">
    <div class="dropdown pl-4">
      <button *ngIf="enableAdvanceSearch && !isAdvanceSearch" type="button"
        class="mb-0 text-underline btn-add-more ng-star-inserted btn btn-clear font-2x" id="advance-search"
        data-toggle="dropdown" aria-haspopup="true"
        [attr.aria-expanded]="enableAdvanceSearch && !isAdvanceSearch ? false : true"
        (click)="showAdvanceSearch($event)">Advanced
        Search
      </button>

      <div class="col-12 p-0 align-items-center d-flex flex-wrap" aria-labelledby="advance-search" *ngIf="isAdvanceSearch">
        <div class="col-auto p-0">
          <app-search-filter [dropdownObject]="dropdownObject" (filterObject)="collectFilterCriteria($event);"
            class="d-flex w-100" #searchFilter></app-search-filter>
        </div>

        <div class="col-auto p-0">
          <button type="button" id="add-more" (click)="addAdvanceSearch()" aria-haspopup="true"
            data-toggle="dropdown" [attr.aria-expanded]="!advanceSearchToggle?false:true"
            [ngStyle]="{'opacity':!advanceSearchToggle ? '1' : '0' }"
            class="text-underline btn btn-clear btn-add-more font-2x position-relative">Add
            more</button>

          <div aria-labelledby="add-more" [ngClass]="advanceSearchToggle ? 'add-more__position': ''"
            [ngStyle]="{'opacity':advanceSearchToggle ? '1' : '0' }">
            <app-advance-search id="ul-panel" [appendMargin]="appendMargin"
              (clickOutside)="toggleAdvanceSearch($event,'close')" #advanceSearch [uniqueId]="uniqueId"
              [listingObj]="advanceSearchList" (advanceFilterObject)="collectAdvanceFilterCriteria($event);"
              [advanceOptionalFilter]="advanceOptionalFilter">
            </app-advance-search>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <div class="col-12 pl-4 d-inline-flex align-items-center mt-1">
    <ng-container *ngFor="let key of Object.keys(advanceOptionalFilter)">
      <div class="auto-complete__choice-tag d-flex my-1 mr-2 p-1 align-items-center"
        *ngFor="let option of advanceOptionalFilter[key];let index=index;">
        <ng-container *ngIf="advanceOptionalFilter[key].length > 0">
          <ng-container>
            <span class="text-truncate d-inline-block tag font-1x"
              title="{{key}} : {{option.name ||option.label}}">{{key}} : {{option.name
              ||option.label}}
            </span>
            <button type="button" (click)="deleteObj(option,$event)" id="deleteSelectedElement"
              class="auto-complete__choice-tag__remove btn-icon cursor-pointer font-2x"
              attr.aria-label="remove {{key}} : {{option.name ||option.label}}">x</button>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>


<!-- Save search start -->
<app-modal *ngIf="isAdvanceSearch" [modalId]="'saveSearch'" [showCloseAlert]="saveSearchForm.dirty" [modalSize]="'small'"
  (closeEvent)="cancleSaveSearch();">
  <modal-div class="title-text">
    Save Search
  </modal-div>

  <modal-div class="body-content">
    <div class="row">
      <div class="col-12 p-0">
        <form [formGroup]="saveSearchForm">
          <div class="form-group col-lg-12 col-sm-12">
            <label class="font-bold" for="saveSearchTitle" id="saveSearchTitleLabel">Title <span
                class="mandatory">*</span></label>
            <input aria-labelledby="saveSearchTitleLabel saveSearchTitleHelp" class="form-control font-bold"
              id="saveSearchTitle" required="" formControlName="search_title" type="text" [(ngModel)]="saveSearchTitle">
            <small class="form-text text-muted text-right" id="saveSearchTitleHelp">Use a title that is easy to
              recognize.
            </small>
          </div>
        </form>
      </div>
    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button class="btn btn-primary btn-sm" data-dismiss="modal" type="button"
      [disabled]="!saveSearchForm.valid || saveSearchTitle?.trim().length===0" (click)="saveSearch()">Save</button>
  </modal-div>
</app-modal>

<!-- view all Search -->
<app-modal *ngIf="isAdvanceSearch" [modalId]="'viewAllRecent'" [modalSize]="'small'">
  <modal-div class="title-text">
    Recent Search
  </modal-div>

  <modal-div class="body-content">
    <div class="search-history">
      <div class="card" *ngFor="let item of recentSearchList">
        <div class="row align-items-center">
          <div class="col-8">
            <h3 class="card-title text-truncate font-bold">
              {{item['search_details']['search_term']}}</h3>
          </div>
          <div class="col-3 text-truncate">
            <p class="mb-0 type">in {{getSearchFrom(item['search_details']['search_optional_filters'])}}</p>
          </div>
          <div class="col-1 py-0 px-2"><button type="button" class="btn btn-clear p-1" (click)="openSavedSearch(item);" data-dismiss="modal">
            <span class="material-icons-outlined font-4x" aria-hidden="true">east</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button class="btn btn-primary btn-sm" data-dismiss="modal" type="button">Save</button>
  </modal-div>
</app-modal>


<app-modal *ngIf="isAdvanceSearch" [modalId]="'viewAllSaved'" [modalSize]="'small'">
  <modal-div class="title-text">
    Saved Search
  </modal-div>

  <modal-div class="body-content">
    <div class="search-history">
      <div class="card">
        <div class="row align-items-center" *ngFor="let item of savedSearchList">
          <div class="col-8">
            <h3 class="card-title text-truncate font-bold">{{item.title}}</h3>
          </div>

          <div class="col-1">
            <button type="button" class="btn btn-icon p-1" (click)="openSavedSearch(item);" data-dismiss="modal">
              <span class="material-icons-outlined font-4x" aria-hidden="true">east</span>
            </button>
          </div>
        </div>
      </div>


    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button class="btn btn-primary btn-sm" data-dismiss="modal" type="button">Save</button>
  </modal-div>
</app-modal>
